<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createSatelite"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t(`mEditionBillingArtificialIntelligence.modal.title.${tab}`) }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <!-- Mismas clases de modal que Satelites: el backoffice usa un solo diseño de modal de alta -->
      <section
        key="modalSection"
        class="m-the-modal-section-height-auto m-satellites-modal"
      >
        <AtomInputPrimary
          v-model="form.titulo"
          :input-error="errors.titulo"
          :label="$t('mEditionBillingArtificialIntelligence.modal.fields.titulo')"
          :message-error="$t('mEditionBillingArtificialIntelligence.modal.errors.titulo')"
          :placeholder="$t(`mEditionBillingArtificialIntelligence.modal.fields.tituloPlaceholder.${tab}`)"
          name="titulo"
          type="text"
        />

        <!-- Los creditos se cargan libres (entero >= 1) y no se editan despues del alta. Debajo se
             ve como va a quedar en la tarjeta, para no confundir 5000 con 50000 -->
        <AtomInputPrimary
          v-model="form.creditos"
          :input-error="errors.creditos"
          :label="$t(`mEditionBillingArtificialIntelligence.modal.fields.creditos.${tab}`)"
          :message="creditosPreview"
          :message-error="$t('mEditionBillingArtificialIntelligence.modal.errors.creditos')"
          :placeholder="$t('mEditionBillingArtificialIntelligence.modal.fields.creditosPlaceholder')"
          min="1"
          name="creditos"
          step="1"
          type="number"
        />

        <h6 class="m-satellites-modal-subtitle margin-top-large">
          {{ $t('mEditionBillingArtificialIntelligence.modal.fields.imagen') }}
        </h6>

        <!-- Miniatura chica al lado del boton: la vista previa muestra el recorte real sin
             estirar el modal -->
        <div class="m-satellites-modal-image-edition">
          <div class="m-satellites-modal-image-thumb">
            <img
              v-if="imagenPreview"
              :alt="form.titulo"
              :src="imagenPreview"
            >
            <img
              v-else
              alt=""
              src="@/assets/img/ds2.png"
            >
          </div>

          <div class="m-satellites-modal-image-actions">
            <a
              class="a-button-billing-secondary"
              href="#"
              @click.prevent="$refs.imagen.click()"
            >
              <i class="far fa-image"></i>
              {{ $t('mEditionBillingArtificialIntelligence.modal.fields.imagenButton') }}
            </a>
          </div>

          <input
            v-show="false"
            ref="imagen"
            accept="image/*"
            name="imagen"
            type="file"
            @change="onImagenChange"
          >
        </div>

        <p class="m-satellites-modal-note">
          <i class="fas fa-info-circle"></i>
          <span>{{ $t('mEditionBillingArtificialIntelligence.modal.hint') }}</span>
        </p>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingArtificialIntelligence.modal.buttons.cancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
// Tope de la columna "creditos" (INT con signo en el core-api)
const MAXIMO_CREDITOS = 2147483647

export default {
  name: 'MoleculeEditionBillingArtificialIntelligenceModal',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingArtificialIntelligence.modal.buttons.submit'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      errors: {
        creditos: false,
        titulo: false
      },

      form: {
        creditos: '',
        imagen: null,
        titulo: ''
      },

      imagenPreview: null,

      sufijo: 'IaMensual',
      tab: 'mensual'
    }
  },

  computed: {
    creditosValidos () {
      const texto = String(this.form.creditos).trim()
      const numero = Number(texto)

      return /^\d+$/.test(texto) && numero >= 1 && numero <= MAXIMO_CREDITOS
    },

    creditosPreview () {
      if (!this.creditosValidos) {
        return ''
      }

      return this.$t(`mEditionBillingArtificialIntelligence.card.creditos.${this.tab}`, {
        creditos: this.$utils.formatCredits(this.form.creditos)
      })
    }
  },

  created () {
    this.sufijo = this.$modal.element.sufijo
    this.tab = this.$modal.element.tab
  },

  methods: {
    onImagenChange (event) {
      const input = event.target

      if (!input.files || !input.files[0]) {
        return
      }

      const archivo = input.files[0]

      // Mismas validaciones que usa app-academy al cambiar la imagen de una tarjeta
      if (!this.$files.allowedFileExtension(archivo.name, 'image')) {
        this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'imagenExtension', 'error', 'a-alert-danger')
        input.value = ''

        return
      }

      if (!this.$files.allowedFileSize(archivo.name, archivo.size)) {
        this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'imagenSize', 'error', 'a-alert-danger')
        input.value = ''

        return
      }

      this.form.imagen = archivo

      const reader = new FileReader()
      reader.onload = (e) => {
        this.imagenPreview = e.target.result
      }
      reader.readAsDataURL(archivo)
    },

    validate () {
      this.errors.titulo = !this.form.titulo ||
        this.form.titulo.length < 3 ||
        this.form.titulo.length > 120
      this.errors.creditos = !this.creditosValidos

      return !this.errors.titulo && !this.errors.creditos
    },

    createSatelite () {
      if (this.buttonPrimary.sending || !this.validate()) {
        return
      }

      this.buttonPrimary.sending = true

      // Nace sin publicar: los creditos no se pueden corregir despues, asi que se revisa la tarjeta
      // antes de activarlo desde el detalle
      const data = {
        satelite: {
          titulo: this.form.titulo,
          creditos: Number(this.form.creditos),
          activo: false
        }
      }

      let creado = false

      this.$services.create('satelite', `createSatelite${this.sufijo}`, data)
        .then(response => {
          creado = true

          // La imagen va aparte, igual que en Satelites y productos: primero existe el plan y despues
          // se le sube el archivo con el id devuelto
          if (this.form.imagen) {
            return this.uploadImagen(response.data.id)
          }
        })
        .then(() => {
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'createSatelite', 'success', 'a-alert-success')
          this.$modal.updateData('readSatelitesIa')
          this.$modal.closeModal()
        })
        .catch(() => {
          if (!creado) {
            this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'createSatelite', 'error', 'a-alert-danger')

            return
          }

          // El plan ya existe y solo fallo la imagen: se cierra y se refresca la lista, para que un
          // segundo "Crear" no deje dos planes iguales
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'uploadImagen', 'error', 'a-alert-danger')
          this.$modal.updateData('readSatelitesIa')
          this.$modal.closeModal()
        })
        .finally(() => {
          this.buttonPrimary.sending = false
        })
    },

    uploadImagen (uuidSatelite) {
      const formData = new FormData()
      formData.append('imagen', this.form.imagen)

      return this.$services.create('satelite', `uploadSatelite${this.sufijo}Imagen`, formData, [uuidSatelite])
    }
  }
}
</script>
